import React, { createContext, useEffect, useReducer } from 'react';
import axios from '../../../axios';
import MatxLoading from "../../components/MatxLoading";

let initialValue = {
    categories: [],
    sub_categories: [],
    sellers: [],
    colors: [],
    sizes: [],
};

const reducer = (state, action) => {
    switch (action.type) {
        case 'LOAD_CATEGORIES_DATA': {
            return {
                ...state,
                add_product_data: { ...state.add_product_data, categories: action.payload.categories },
            }
        }
        case 'LOAD_SUB_CATEGORIES_DATA': {
            return {
                ...state,
                add_product_data: { ...state.add_product_data, sub_categories: action.payload.sub_categories },
            }
        }
        case 'LOAD_SELLER_DATA': {
            return {
                ...state,
                add_product_data: { ...state.add_product_data, sellers: action.payload.sellers },
            }
        }
        case 'LOAD_COLORS_DATA': {
            return {
                ...state,
                add_product_data: { ...state.add_product_data, colors: action.payload.colors },
            }
        }
        case 'LOAD_SIZES_DATA': {
            return {
                ...state,
                add_product_data: { ...state.add_product_data, sizes: action.payload.sizes },
            }
        }
        default: {
            return state
        }
    }
}

const AddProductContext = createContext({
    add_product_data: initialValue,
    getCategories: () => { },
    getSubCategories: () => { },
    getSellers: () => { },
    getColors: () => { },
    getSizes: () => { },
    addProduct: () => { },
    editProduct: () => { },
    getProductDetail: () => { },
    uploadImage: () => { },
})



export const AddProductsProvider = ({ settings, children }) => {
    const [state, dispatch] = useReducer(reducer, initialValue)

    const getCategories = async () => {
        const all_categories = window.localStorage.getItem('all_categories');
        if (all_categories !== undefined && all_categories !== "" && all_categories !== null) {
            dispatch({
                type: 'LOAD_CATEGORIES_DATA',
                payload: JSON.parse(all_categories),
            })
        }

        const accessToken = window.localStorage.getItem('accessToken')

        try {
            const options = {
                headers: {
                    'Authorization': 'Bearer ' + accessToken,
                    'Content-Type': 'application/x-www-form-urlencoded',
                }
            }

            const res = await axios.get('/api/categories/get_categories', options);

            window.localStorage.setItem('all_categories', JSON.stringify(res.data));

            dispatch({
                type: 'LOAD_CATEGORIES_DATA',
                payload: res.data,
            })
        } catch (e) {
            console.error(e)
        }
    }

    const getSubCategories = async (category_id) => {
        dispatch({
            type: 'LOAD_SUB_CATEGORIES_DATA',
            payload: { sub_categories: [] },
        })

        const accessToken = window.localStorage.getItem('accessToken')

        try {
            const options = {
                headers: {
                    'Authorization': 'Bearer ' + accessToken,
                    'Content-Type': 'application/x-www-form-urlencoded',
                }
            }

            const res = await axios.get('/api/categories/get_sub_categories/' + category_id, options);

            dispatch({
                type: 'LOAD_SUB_CATEGORIES_DATA',
                payload: res.data,
            })
        } catch (e) {
            console.error(e)
        }
    }

    const getSellers = async (params = {}) => {
        const all_sellers = window.localStorage.getItem('all_sellers');
        if (all_sellers !== undefined && all_sellers !== "" && all_sellers !== null) {
            dispatch({
                type: 'LOAD_SELLER_DATA',
                payload: JSON.parse(all_sellers),
            })
        }

        const accessToken = window.localStorage.getItem('accessToken')

        try {
            const options = {
                params,
                headers: {
                    'Authorization': 'Bearer ' + accessToken,
                    'Content-Type': 'application/x-www-form-urlencoded',
                }
            }

            const res = await axios.get('/api/sellers/get_all_sellers', options);
            window.localStorage.setItem('all_sellers', JSON.stringify(res.data));
            dispatch({
                type: 'LOAD_SELLER_DATA',
                payload: res.data,
            })
        } catch (e) {
            console.error(e)
        }
    }

    const uploadImage = async (data) => {
        try {
            const options = {
                headers: { 'Content-Type': 'multipart/form-data' }
            }

            const res = await axios.post('/api/upload_product_image', data, options);

            return res.data;
        } catch (e) {
            console.error(e)
            alert(JSON.stringify(e));
            return null;
        }
    }

    const getColors = async (category_id) => {
        const accessToken = window.localStorage.getItem('accessToken')

        try {
            const options = {
                headers: {
                    'Authorization': 'Bearer ' + accessToken,
                    'Content-Type': 'application/x-www-form-urlencoded',
                }
            }

            const res = await axios.get('/api/products/get_colors/' + category_id, options);

            dispatch({
                type: 'LOAD_COLORS_DATA',
                payload: res.data,
            })
        } catch (e) {
            console.error(e)
        }
    }


    const getSizes = async (category_id) => {
        const accessToken = window.localStorage.getItem('accessToken')

        try {
            const options = {
                headers: {
                    'Authorization': 'Bearer ' + accessToken,
                    'Content-Type': 'application/x-www-form-urlencoded',
                }
            }

            const res = await axios.get('/api/products/get_sizes/' + category_id, options);

            dispatch({
                type: 'LOAD_SIZES_DATA',
                payload: res.data,
            })
        } catch (e) {
            console.error(e)
        }
    }

    const addProduct = async (data) => {
        const accessToken = window.localStorage.getItem('accessToken')

        try {
            const options = {
                headers: {
                    'Authorization': 'Bearer ' + accessToken,
                    'Content-Type': 'application/json',
                }
            }

            const res = await axios.post('/api/products/add_product/', data, options);

            return res;
        } catch (e) {
            console.error(e);
            return e;
        }
    }

    const editProduct = async (data) => {
        const accessToken = window.localStorage.getItem('accessToken')

        try {
            const options = {
                headers: {
                    'Authorization': 'Bearer ' + accessToken,
                    'Content-Type': 'application/json',
                }
            }

            const res = await axios.post('/api/products/edit_product/', data, options);

            return res;
        } catch (e) {
            console.error(e);
            return e;
        }
    }

    const getProductDetail = async (id) => {
        const accessToken = window.localStorage.getItem('accessToken')

        try {
            const options = {
                headers: {
                    'Authorization': 'Bearer ' + accessToken,
                    'Content-Type': 'application/json',
                }
            }

            const res = await axios.get('/api/products/get_product_detail/' + id, options);

            return res.data;
        } catch (e) {
            console.error(e);
            return e;
        }
    }

    useEffect(() => {
        getCategories();
        getSellers();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])

    if (state.add_product_data === undefined) {
        return <MatxLoading />
    }

    return (
        <AddProductContext.Provider
            value={{
                add_product_data: state.add_product_data,
                getCategories,
                getSubCategories,
                getSellers,
                getColors,
                getSizes,
                addProduct,
                editProduct,
                getProductDetail,
                uploadImage,
            }}
        >
            {children}
        </AddProductContext.Provider>
    )
}

export default AddProductContext
